import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetSmartyAutocompleteApiParameter extends ApiParameter {
    search: string;
}

export interface AddressSuggestion {
    street_line: string;
    secondary?: string;
    city: string;
    state: string;
    zipcode: string;
    entries: string;
}

const smartyAutocompleteApiUrl = "/api/v1/smarty/autocomplete/suggestions";

/**
 * Fetches address autocomplete suggestions from the Smarty Streets API
 * @param parameter - API parameters including the search query
 * @returns Promise resolving to an array of address suggestions
 */
export function getSmartyAutocompleteSuggestions(parameter?: GetSmartyAutocompleteApiParameter) {
    return get<AddressSuggestion[]>(smartyAutocompleteApiUrl, parameter);
}

/**
 * Fetches address suggestions with a specific search query and optional limit
 * @param search - The search string for autocomplete
 * @param limit - Maximum number of suggestions to return (optional, default: 10)
 * @returns Promise resolving to an array of address suggestions
 */
export function searchSmartyAddresses(search: string) {
    return getSmartyAutocompleteSuggestions({
        search,
    });
}
